import React from 'react';
import 'assets/scss/info-box.scss';

type InfoBoxProps = {
	title: string;
	content: any;
	margin: string;
};

export const InfoBox = ({ title, content, margin }: InfoBoxProps) => {
	return (
		<div
			className="info-box-container"
			style={{
				margin: margin,
			}}
		>
			<h3 className="small-bold primary-color" style={{ marginBottom: 8 }}>
				{title}
			</h3>
			<div className="small gris-6">{content}</div>
		</div>
	);
};
